import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { AuthState } from 'src/store/auth/types';

export default function useIsAuthenticated() {
  const { authenticated } = useSelector<RootState, AuthState>((state) => state.authState);
  return authenticated;
}
